import { HttpClient, HttpContext } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, ElementRef, effect, inject, input } from "@angular/core";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Observable, shareReplay, tap } from "rxjs";

import { CAH, SvgName } from "@models";

const CACHE_SVG_MAP: Record<string, Observable<string>> = {};

@UntilDestroy()
@Component({
  template: "",
  selector: "mn-svg",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgComponent {
  public readonly eR = inject(ElementRef);
  private readonly hC = inject(HttpClient);

  public name = input.required<SvgName>();

  constructor() {
    effect(() => {
      const name = this.name();

      if (!name) {
        return;
      }

      if (!CACHE_SVG_MAP[name]) {
        CACHE_SVG_MAP[name] = this.hC
          .get(`assets/images/svg/${name}.svg`, {
            responseType: "text",
            context: new HttpContext().set(CAH, false),
          })
          .pipe(shareReplay(1));
      }

      const request$ = CACHE_SVG_MAP[name];
      request$
        .pipe(
          tap(svg => (this.eR.nativeElement.innerHTML = svg)),
          untilDestroyed(this),
        )
        .subscribe();
    });
  }
}
